/**
 * Source d'aléa et identifiants.
 *
 * `crypto.getRandomValues` est disponible dans tous les contextes, y compris
 * non sécurisés (contrairement à `crypto.subtle`). Les codes individuels sont
 * donc imprévisibles même sur une urne en réseau local sans HTTPS.
 */

/** Remplit un tableau d'octets aléatoires. */
export function randomBytes(length: number): Uint8Array {
  const buffer = new Uint8Array(length);
  crypto.getRandomValues(buffer);
  return buffer;
}

/**
 * Entier aléatoire dans [0, max), sans biais modulo.
 * Le rejet garantit une distribution uniforme, condition d'un tirage loyal.
 */
export function randomInt(max: number): number {
  if (!Number.isInteger(max) || max <= 0) {
    throw new RangeError(`randomInt attend un entier positif, reçu ${String(max)}`);
  }
  const limit = Math.floor(0x100000000 / max) * max;
  const buffer = new Uint32Array(1);
  let value = 0;
  do {
    crypto.getRandomValues(buffer);
    value = buffer[0] as number;
  } while (value >= limit);
  return value % max;
}

/** Identifiant opaque préfixé, unique en pratique. */
export function randomId(prefix: string): string {
  const bytes = randomBytes(12);
  let out = '';
  for (const byte of bytes) {
    out += byte.toString(16).padStart(2, '0');
  }
  return `${prefix}_${out}`;
}
